export const MASTER_API_URL = process.env.NEXT_PUBLIC_MASTER_API_URL || "";

export function getApiUrl(path: string) {
  if (!MASTER_API_URL) return path;
  return `${MASTER_API_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
}
